<template>
  <div class="final-price-cell">

    <div v-if="!subsidy" class="no-discount">
      İndirimli fiyat bulunmuyor.
    </div>

    <template v-else>

      <div class="subsidy-badge">
        <span>{{ subsidy.discountShareTypeName }}</span>

        <TooltipPlugin 
          :tooltipText="tooltipText" 
          position="bottom"
          :tooltipWidth="180"
        >
          <template #tooltip-btn>
            <Icons name="InfoCircle"  color="#6B6B6B" />
          </template>
        </TooltipPlugin>
      </div>

      <div class="breakdown-container">
        <template v-if="isShared">
          <div class="breakdown-grid">
            <span class="label">n11 Desteği</span>
            <span class="colon">:</span>
            <span class="value">₺{{ formatPrice(subsidy.n11ShareAmount) }}</span>

            <span class="label">Satıcı Desteği</span>
            <span class="colon">:</span>
            <span class="value">₺{{ formatPrice(subsidy.sellerShareAmount) }}</span>

            <span class="label">Toplam İndirim</span>
            <span class="colon">:</span>
            <span class="value">₺{{ formatPrice(subsidy.totalAmount) }}</span>
          </div>
        </template>

        <template v-else>
          <div class="breakdown-grid">
            <span class="label">İndirim Tutarı</span>
            <span class="colon">:</span>
            <span class="value">₺{{ formatPrice(subsidy.totalAmount) }}</span>
          </div>
        </template>
      </div>

      <div class="final-price-row">
        <svg viewBox="0 0 24 24" width="16" height="16" stroke="#1C1C1E" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round">
          <path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"></path>
          <line x1="7" y1="7" x2="7.01" y2="7"></line>
        </svg>
        <span class="price-text">₺{{ formatPrice(finalPrice) }}</span>
      </div>

    </template>
  </div>
</template>

<script>
import { TooltipPlugin, Icons } from '@n11/so-ui-components';

export default {
  name: 'FinalPriceCell',
  components: {
    TooltipPlugin,
    Icons
  },
  props: {
    finalPrice: {
      type: Number,
      required: true
    },
    subsidy: {
      type: Object,
      required: false,
      default: null
    },
  },
  computed: {
    isShared() {
      if (!this.subsidy || !this.subsidy.discountShareTypes) return false;
      return this.subsidy.discountShareTypes.includes('N11') && 
             this.subsidy.discountShareTypes.includes('SELLER');
    },
    tooltipText() {
      if (!this.subsidy) return '';
      
      if (this.isShared) {
        return 'İndirim tutarı n11 ve satıcı tarafından birlikte karşılanır.';
      } else if (this.subsidy.discountShareTypes.includes('N11')) {
        return 'İndirim tutarının tamamı n11 tarafından karşılanır.';
      } else if (this.subsidy.discountShareTypes.includes('SELLER')) {
        return 'İndirim tutarının tamamı satıcı tarafından karşılanır.';
      }
      return '';
    }
  },
  methods: {
    formatPrice(value) {
      if (value === null || value === undefined) return '0,00';
      return new Intl.NumberFormat('tr-TR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(value);
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/assets/styles/variables.scss';

.final-price-cell {
  display: inline-flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 4px;
  padding: 12px;
}

.no-discount {
  color: $colorN70;
  font-size: 13px;
}

.subsidy-badge {
  height: 24px;
  padding: 2px 6px;
  background: $colorN10;
  border-radius: 4px;
  border: 0.5px solid $colorN70;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  gap: 2px;
  
  span {
    color: $colorN70;
    font-size: 11px;
    font-weight: 600;
    line-height: 14px;
  }

  :deep(.icon svg) {
    width: 16px;
    height: 16px;
  }
}

.info-icon {
  width: 16px;
  height: 16px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.breakdown-container {
  width: 179px;
  display: inline-flex;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 4px;
}

.breakdown-grid {
  display: grid;
  grid-template-columns: 80px 4px auto;
  row-gap: 2px;
  column-gap: 4px;
  width: 100%;

  .label {
    color: $colorN70;
    font-size: 11px;
    font-weight: 400;
    line-height: 14px;
  }

  .colon {
    color: $colorN70;
    font-size: 11px;
    font-weight: 400;
    line-height: 14px;
  }

  .value {
    color: $colorN80;
    font-size: 11px;
    font-weight: 600;
    line-height: 14px;
  }
}

.final-price-row {
  display: inline-flex;
  justify-content: flex-start;
  align-items: center;
  gap: 2px;

  .price-text {
    color: $colorN80;
    font-size: 13px;
    font-weight: 600;
    line-height: 18px;
  }
}

</style>